// extracted by mini-css-extract-plugin
export default {"halloween":"Halloween_halloween__ovzfa"};